import { ScenarioFormStructureTable } from "components/Tables/ScenarioFormStructureTable/ScenarioFormStructureTable.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute, RouteStaticData } from "utils/createTenantFileRoute.ts";

const staticData: RouteStaticData = {
    permissions: [PermissionEnum.ToolScenarioField],
    showInSideMenu: true,
    sideMenuParent: "lazy",
    label: "pages.tool.scenario.validation.title",
    sort: 3,
};

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout/validation/")({
    component: ValidationPage,
    staticData,
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.tool.scenario.validation.title"),
    }),
});

function ValidationPage() {
    return (
        <TenantPage>
            <ScenarioFormStructureTable />
        </TenantPage>
    );
}

// Delay sideMenuParent after parent route is initialized
import("routes/_authenticated/$tenantSlug/_layout/tool/index.tsx").then((mod) => {
    staticData.sideMenuParent = mod.Route;
});
